module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pd-bottom-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("                  \n                " + _vm._s(_vm.title) + "\n              ")])])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Name\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Activation\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Pairing\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                CO-Creating\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Completion\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Overall Average\n                            ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.top5Rows), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "left-div-border",
            style: ({
              'border-left-color': _vm.theme
            })
          }), _vm._v("\n                              " + _vm._s(item.name) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.ACTIVATION) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.PAIRING) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.CREATING) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.COMPLETE) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.Overall) + "\n                            ")])])
        }), _vm._v(" "), _c('tr', [_c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "left-div-border",
          style: ({
            'border-left-color': _vm.theme
          })
        }), _vm._v("\n                              Team\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.activation) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.pairing) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.creating) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.complete) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.overall) + "\n                            ")])])], 2)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mg-top-0"
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "text": "",
      "color": _vm.theme
    },
    on: {
      "click": _vm.seeMoreModalOpen
    }
  }, [_vm._v("See More...")])], 1)], 1)], 1), _vm._v(" "), _c('see-more', {
    attrs: {
      "dialog": _vm.seeMoreDialog,
      "title": _vm.title,
      "closeDialog": _vm.seeMoreModalClose,
      "headers": _vm.headers,
      "DataItems": _vm.items,
      "total": _vm.total.all,
      "theme": _vm.theme,
      "type": "duration"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60046f72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/DurationStage.vue
// module id = 2151
// module chunks = 0